import { getUnixTime } from 'date-fns'
import { jwtDecode, JwtPayload } from 'jwt-decode'

import { getItem } from './storage'

type AuthTokenPayload = JwtPayload & {
  customerId: string
  userId: string
  email: string
  tokenRequestedFrom: string
}

export const isTokenValid = (token: string | undefined): boolean => {
  if (token) {
    const decoded = jwtDecode<AuthTokenPayload>(token)
    const now = getUnixTime(new Date())
    if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {
      return false
    }
    if (typeof decoded.nbf !== 'undefined' && decoded.nbf > now) {
      return false
    }
    return true
  }
  return false
}

export const isCurrentTokenValid = (): boolean => {
  const currentToken = getItem<string | undefined>('token')
  return isTokenValid(currentToken)
}

type TokenUserDetails = {
  customerId: string
  userId: string
  email: string
}

export const getUserDetailsFromCurrentToken = (): TokenUserDetails | undefined => {
  const currentToken = getItem<string | undefined>('token')
  if (currentToken) {
    const decoded = jwtDecode<AuthTokenPayload>(currentToken)
    return {
      customerId: decoded.customerId,
      userId: decoded.userId,
      email: decoded.email,
    }
  }
  return undefined
}
